import { DatatableRow } from '@monksflow/monks-ui';
import clsx from 'clsx';
import type { ReactNode, Ref } from 'react';

export interface TableSkeletonRowProps {
  /**
   * Overridable so per-table queries (`briefs-table-skeleton-row`,
   * `projects-table-skeleton-row`, etc.) keep resolving after the
   * migration. Defaults to `data-table-skeleton-row`.
   */
  testId?: string;
  className?: string;
  /** Caller-supplied skeleton cells — column count stays at the call site. */
  children: ReactNode;
  /** React 19 ref-as-prop: forwarded to the underlying `<tr>`. */
  ref?: Ref<HTMLTableRowElement>;
}

/**
 * Skeleton `<tr>` composed on monks-ui `DatatableRow`. The row carries
 * only `h-20` + the overridable `data-testid`; the caller supplies the
 * cells (usually `<Skeleton>` blocks). `aria-busy` is intentionally NOT
 * set here — per design D5 the single source of truth is
 * `<Datatable aria-busy={...}>` at the call site.
 */
export const TableSkeletonRow = ({
  testId = 'data-table-skeleton-row',
  className,
  children,
  ref,
}: TableSkeletonRowProps) => (
  <DatatableRow ref={ref} data-testid={testId} className={clsx('h-20', className)}>
    {children}
  </DatatableRow>
);
TableSkeletonRow.displayName = 'TableSkeletonRow';
